






import { defineComponent } from "@vue/composition-api";
import router from "@/router";

export default defineComponent({
  setup() {
    return {
      errorMessage: router.currentRoute.query.errorMessage,
    };
  },
});
